import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ZoomRegistrationFallbackModal = ({
  fallbackUrl,
  onClose,
  onCtaClick
}) => /*#__PURE__*/_jsxs(Modal, {
  use: "info",
  width: 540,
  children: [/*#__PURE__*/_jsxs(DialogHeader, {
    children: [/*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyComponents.liveEventOverviewModal.registrationFallbackTitle"
      })
    }), /*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    })]
  }), /*#__PURE__*/_jsx(DialogBody, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyComponents.liveEventOverviewModal.registrationFallbackBody"
    })
  }), /*#__PURE__*/_jsx(DialogFooter, {
    align: "center",
    children: /*#__PURE__*/_jsx(Button, {
      external: true,
      href: fallbackUrl,
      onClick: () => {
        onCtaClick === null || onCtaClick === void 0 || onCtaClick();
        onClose();
      },
      target: "_blank",
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyComponents.liveEventOverviewModal.registrationFallbackCta"
      })
    })
  })]
});
export { ZoomRegistrationFallbackModal };